<div class="justify-content-center align-items-center row">
  @if (showToast) {
    <div class="alert" [ngClass]="alertClass" role="alert">
      {{ errorResponse.code }} - {{ errorResponse.message }}
    </div>
  }

</div>
